module.exports = __webpack_public_path__ + "accaa8ab806e97523fe3a0cd5392be63.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/zombie-glasses.png
// module id = 2482
// module chunks = 0